module.exports = __webpack_public_path__ + "static/media/pn.a7cc83d2.svg";